<div class="container-fluid">
    <div class="table-header">
        <h5 [class.required]="required">Equipment data E1</h5>

        <div class="controls">
            <button mat-button (click)="addEquipment()" [disabled]="!(canEdit$ | async)">
                <mat-icon svgIcon="plus" />
                Add Equipment
            </button>

            @if (showDelete) {
                <button mat-button (click)="deleteEquipment()" [disabled]="!(canEdit$ | async)">
                    <mat-icon svgIcon="trash-can" />
                    Delete
                </button>
            } 
            
            <button mat-button (click)="refresh()" [disabled]="!(canEdit$ | async)">
                <mat-icon>refresh</mat-icon>
                Refresh
            </button>
            
            @if (isDev) {
                <button mat-button (click)="export()" disabled>
                    <mat-icon svgIcon="save" />
                    Export Equipment
                </button>
            }
        </div>
    </div>

    <div class="table-container">
        <div class="table-scroll-wrapper">
            <table mat-table [dataSource]="dataSource" matSort class="report-table" fixedLayout="true">
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()"
                            aria-label="Select all"></mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()" (change)="checkRow(row)"
                            [checked]="selection.isSelected(row)"
                            aria-label="Select row"></mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="equipmentTag">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Equipment Tag">
                        Equipment Tag
                        <app-table-column-filter class="column-filter" [class.active]="isActive('equipmentTag')" (filterChange)="applyFilter($event, 'equipmentTag')" />
                    </th>
                    <td mat-cell *matCellDef="let report">
                        <a class="blue-link" [routerLink]="['edit', report.id]">{{ report.equipmentTag }}</a>
                    </td>
                </ng-container>

                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort by Description [EN]">
                        Description [EN]
                        <app-table-column-filter class="column-filter" [class.active]="isActive('description')" (filterChange)="applyFilter($event, 'description')" />
                    </th>
                    <td mat-cell *matCellDef="let report">{{ report.description }}</td>
                </ng-container>

                <ng-container matColumnDef="equipmentClass">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort by Equipment Class">
                        Equipment Class
                        <app-table-column-filter class="column-filter" [class.active]="isActive('equipmentClass')" (filterChange)="applyFilter($event, 'equipmentClass')" />
                    </th>
                    <td mat-cell *matCellDef="let report">{{ report.equipmentClass }}</td>
                </ng-container>

                <ng-container matColumnDef="equipmentSubclass">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort by name Equipment Subclass">
                        Equipment Subclass
                        <app-table-column-filter class="column-filter" [class.active]="isActive('equipmentSubclass')" (filterChange)="applyFilter($event, 'equipmentSubclass')" />
                    </th>
                    <td mat-cell *matCellDef="let report">{{ report.equipmentSubclass }}</td>
                </ng-container>

                <ng-container matColumnDef="integrityCriticality">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort by Integrity consequence">
                        Integrity consequence
                        <app-table-column-filter class="column-filter" [class.active]="isActive('integrityCriticality')" (filterChange)="applyFilter($event, 'integrityCriticality')" />
                    </th>
                    <td mat-cell *matCellDef="let report">{{ report.integrityCriticality }}</td>
                </ng-container>

                <ng-container matColumnDef="assetConsequence">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort by Asset consequence">
                        Asset consequence
                        <app-table-column-filter class="column-filter" [class.active]="isActive('assetConsequence')" (filterChange)="applyFilter($event, 'assetConsequence')" />
                    </th>
                    <td mat-cell *matCellDef="let report">{{ report.assetConsequence }}</td>
                </ng-container>

                <ng-container matColumnDef="facility">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Facility">
                        Facility
                        <app-table-column-filter class="column-filter" [class.active]="isActive('facility')" (filterChange)="applyFilter($event, 'facility')" />
                    </th>
                    <td mat-cell *matCellDef="let report">{{ report.facility }}</td>
                </ng-container>

                <ng-container matColumnDef="area">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Area">
                        Area
                        <app-table-column-filter class="column-filter" [class.active]="isActive('area')" (filterChange)="applyFilter($event, 'area')" />
                    </th>
                    <td mat-cell *matCellDef="let report">{{ report.area }}</td>
                </ng-container>

                <ng-container matColumnDef="unit">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Unit">
                        Unit
                        <app-table-column-filter class="column-filter" [class.active]="isActive('unit')" (filterChange)="applyFilter($event, 'unit')" />
                    </th>
                    <td mat-cell *matCellDef="let report">{{ report.unit }}</td>
                </ng-container>

                <ng-container matColumnDef="equipmentStatus">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort by Equipment status">
                        Equipment status
                        <app-table-column-filter class="column-filter" [class.active]="isActive('equipmentStatus')" (filterChange)="applyFilter($event, 'equipmentStatus')" />
                    </th>
                    <td mat-cell *matCellDef="let report">{{ report.equipmentStatus }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"
                    [class.selected]="selection.isSelected(row)" [class.disabled]="row.status === 'Inactive'"></tr>

            </table>
        </div>
        <mat-paginator [pageSizeOptions]="pageSizeOptions" [length]="dataSource.data.length"
            showFirstLastButtons></mat-paginator>
    </div>
</div>